import React, { useEffect, useState } from "react";
import { Select } from "antd";

const { Option } = Select;

const opts = ["ทั้งประเทศ","กระบี่", "กรุงเทพมหานคร", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทลุง", "พิจิตร", "พิษณุโลก", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "ยะลา", "ยโสธร", "ระนอง", "ระยอง", "ราชบุรี", "ร้อยเอ็ด", "ลพบุรี", "ลำปาง", "ลำพูน", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสงคราม", "สมุทรสาคร", "สระบุรี", "สระแก้ว", "สิงห์บุรี", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "สุโขทัย", "หนองคาย", "หนองบัวลำภู", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี", "อ่างทอง", "เชียงราย", "เชียงใหม่", "เพชรบุรี", "เพชรบูรณ์", "เลย", "แพร่", "แม่ฮ่องสอน"];

const ProvinceLimited = (props) => {
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [optionsSelectedProps, setOptionsSelectedProps] = useState([]);

  useEffect(() => {
    setOptionsSelected(["ทั้งประเทศ","กรุงเทพมหานคร"]);
    setOptionsSelectedProps([
        {label: "ทั้งประเทศ", value: "ทั้งประเทศ"},
        {label: "กรุงเทพมหานคร", value: "กรุงเทพมหานคร"}
    ]);
  },[]);

  const handleChange = value => {
    let tempState = [];
    value.forEach(d => {
        tempState.push({label: d, value: d});
    });
    setOptionsSelectedProps(tempState);
    setOptionsSelected(value);
  };

  props.onChange(optionsSelectedProps);

  return (
    <div>
      <Select
        mode="multiple"
        style={{ width: "100%" }}
        placeholder="Please select"
        onChange={handleChange}
        defaultValue={["ทั้งประเทศ","กรุงเทพมหานคร"]}
      >
        {opts.map(item => (
          <Option
            style={{color: '#70ad47', fontFamily: 'Helvetica', fontSize: '15px' }}
            disabled={
              optionsSelected.length > 1
                ? optionsSelected.includes(item)
                  ? false
                  : true
                : false
            }
            key={item}
          >
            {item}
          </Option>
        ))}
      </Select>
    </div>
  );
}

export default ProvinceLimited;